import '../scss/article.scss';
import menuModule from "./modules/menu.js";
import tableOfContentModule from "./modules/tableOfContentModule.js";
import faqModule from "./modules/faqModule.js";
import commentsModule from "./modules/commentsModule.js";
import scrollUpModule from "./modules/scrollUpModule.js";
import footerModule from "./modules/footerModule.js";
import rateAndShareModule from "./modules/rateAndShareModule.js";
import sendPulseFormModule from "./modules/sendPulseFormModule.js";
import scrollSidebarModule from "./modules/scrollSidebarModule.js";
import timersModule from "./modules/timersModule.js";

import priceCoinWidget from "./widgets/price-coin-widget.js";

(function ($) {
    $(document).ready(function () {
        window.$ = jQuery;

        menuModule.init();
        tableOfContentModule.init();
        faqModule.init();
        commentsModule.init();
        scrollUpModule.init();
        footerModule.init();
        priceCoinWidget.init();
        rateAndShareModule.init();
        sendPulseFormModule.init();
        scrollSidebarModule.init();
        timersModule.init();

        $('[data-disclaimer-btn]').click(e => {
            e.preventDefault();
            $(e.target).closest('.disclaimer').toggleClass('disclaimer-open');

            console.log(e.target)
        });


        // Добавляем таблицам отзывчивости
        const tables = $('table');

        tables.each(function (tableIndex, table) {
            if(!$(table).closest('.table-responsive').length) {
                $(table).wrap('<div class="table-responsive"></div>')
            }
        })

        $(document).scroll(function () {
            $('div + h2').each(function (i, el) {
                const targetDiv = $(el).prev('div')[0];
                const scroll = targetDiv.getBoundingClientRect().y

                if(scroll > -50 && scroll < 50){
                    $('.sidebar-titles__list-item').removeClass('current')
                    const a = $(`.sidebar-titles__list-item a[href="#${targetDiv.id}"]`)[0];

                    if(a) {
                        $(a).parent().addClass('current')
                    }
                }
            })
        })


        // догружаем стили от expert review плагина. Отключили в actions
        // window.addEventListener('load', function() {
        //     let link = document.createElement('link');
        //     link.rel = 'stylesheet';
        //     link.href = '/wp-content/plugins/expert-review/assets/public/css/styles.min.css';
        //     document.head.appendChild(link);
        // });
    });
}(jQuery));
